import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "andet",
  "use": "andet-usage",
  "viewBox": "0 0 83.3 102.9",
  "content": "<symbol viewBox=\"0 0 83.3 102.9\" id=\"andet\"><path fill=\"#db8027\" d=\"M67.6 30.3H54.4V13.9H15.6V89h52\" /><path fill=\"#bd6f29\" d=\"M67.6 30.3L54.4 13.9v16.4h13.2\" /><path fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\" d=\"M46.7 46.1H53v12.4H30.3V46.1h6.5\" /><path fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" d=\"M41.6 52.2v-9.4\" /><path fill=\"#fff\" d=\"M45.5 43.9l-3.9-6.6-3.8 6.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/andet.svg
// module id = pO7ru
// module chunks = 1